
import React from "react";
import { Github } from 'lucide-react';
import { motion } from "framer-motion";

const projectsData = [
    {
        title: 'Doctor Appointment (React)',
        image: 'https://placehold.co/600x400/1a202c/ffffff?text=Doctor+App',
        description: 'A comprehensive platform for patients to find doctors and book appointments online. Features include doctor profiles, available slots, and booking management.',
        technologies: ['React.js', 'Node.js', 'Express', 'MongoDB'],
        githubLink: 'https://github.com/Rajanbhalodiya/doctorProject.git',
    },
    {
        title: 'Grocery Shopping (React)',
        image: 'https://placehold.co/600x400/1a202c/ffffff?text=React+Grocery',
        description: 'Developed a dynamic and responsive grocery shopping application using React.js. Enhanced user experience with a clean and intuitive UI using React Hooks and Material-UI.',
        technologies: ['React.js', 'Redux', 'Node.js', 'CSS'],
        githubLink: 'https://github.com/Rajanbhalodiya/groceryapp.git',
    },
    {
        title: 'Grocery Shopping (PHP)',
        image: 'https://placehold.co/600x400/1a202c/ffffff?text=PHP+Grocery',
        description: 'Built a web-based grocery shopping application using PHP and MySQL. Features included user registration, login, shopping list creation, and a product catalog with search/filter options.',
        technologies: ['PHP', 'MySQL', 'HTML', 'CSS', 'JavaScript'],
        githubLink: 'https://github.com/Rajanbhalodiya/Groceryy.git',
    },
    {
        title: 'Rajan Farm (React)',
        image: 'https://placehold.co/600x400/1a202c/ffffff?text=Rajan+Farm',
        description: 'A modern website for online farm product selling and order in whatsapp. Implemented responsive design and English , gujarati and hindi translations support.',
        technologies: ['React.js'],
        githubLink: 'https://github.com/Rajanbhalodiya/Rajan_Farm.git',
        liveLink: 'https://rajan-farm.vercel.app/',
    },
];


const fadeInUp = {
    hidden: { opacity: 0, y: 40 },
    visible: (i = 1) => ({
        opacity: 1,
        y: 0,
        transition: { delay: i * 0.2, duration: 0.7, ease: "easeOut" }
    })
};

const Projects = ({ id }) => (
    <section id={id} className="py-20 px-4">
        <div className="container mx-auto">
                    <motion.h2
                        className="text-3xl md:text-4xl font-bold text-center mb-12 text-white"
                        initial="hidden"
                        animate="visible"
                        variants={fadeInUp}
                        custom={1}
                    >
                        Projects
                        <div className="w-24 h-1 bg-cyan-400 mx-auto mt-2 rounded"></div>
                    </motion.h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {projectsData.map((project, idx) => (
                            <motion.div
                                key={project.title}
                                className="bg-gray-800 rounded-lg overflow-hidden shadow-lg hover:shadow-cyan-500/30 transition-all duration-300 transform hover:-translate-y-2"
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true, amount: 0.5 }}
                                variants={fadeInUp}
                                custom={idx + 2}
                                whileHover={{ scale: 1.05, rotate: 2 }}
                            >
                                <motion.img
                                    src={project.image}
                                    alt={project.title}
                                    className="w-full h-48 object-cover"
                                    initial={{ scale: 0.8, opacity: 0 }}
                                    whileInView={{ scale: 1, opacity: 1 }}
                                    viewport={{ once: true, amount: 0.5 }}
                                    transition={{ delay: 0.8 + idx * 0.2, duration: 0.8, type: "spring" }}
                                    whileHover={{ scale: 1.08, rotate: 2 }}
                                />
                                <div className="p-6">
                                    <motion.h3
                                        className="text-2xl font-bold text-white mb-2"
                                        initial={{ color: "#fff" }}
                                        whileInView={{ color: ["#06b6d4", "#fff", "#06b6d4"] }}
                                        viewport={{ once: true, amount: 0.5 }}
                                        transition={{ duration: 2, repeat: Infinity, repeatType: "reverse" }}
                                    >
                                        {project.title}
                                    </motion.h3>
                                    <motion.p
                                        className="text-gray-400 mb-4"
                                        initial="hidden"
                                        whileInView="visible"
                                        viewport={{ once: true, amount: 0.5 }}
                                        variants={fadeInUp}
                                        custom={idx + 3}
                                    >
                                        {project.description}
                                    </motion.p>
                                    <div className="flex flex-wrap gap-2 mb-4">
                                        {project.technologies.map((tech, tIdx) => (
                                            <motion.span
                                                key={tech}
                                                className="bg-gray-700 text-cyan-300 text-xs font-semibold px-2.5 py-1 rounded-full"
                                                initial={{ opacity: 0, y: 20 }}
                                                whileInView={{ opacity: 1, y: 0 }}
                                                viewport={{ once: true, amount: 0.5 }}
                                                transition={{ delay: 1 + tIdx * 0.1, duration: 0.5, ease: "easeOut" }}
                                            >
                                                {tech}
                                            </motion.span>
                                        ))}
                                    </div>
                                    <div className="flex justify-end items-center mt-6 gap-3">
                                        <motion.a
                                            href={project.githubLink}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-gray-400 hover:text-white flex items-center gap-2 transition-colors"
                                            whileHover={{ scale: 1.08 }}
                                        >
                                            <Github size={18} /> Source Code
                                        </motion.a>
                                        {project.liveLink && (
                                            <motion.a
                                                href={project.liveLink}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="text-cyan-400 hover:text-cyan-300 transition-colors"
                                                whileHover={{ scale: 1.08 }}
                                            >
                                                Live Demo
                                            </motion.a>
                                        )}
                                    </div>
                                </div>
                            </motion.div>
                        ))}
            </div>
        </div>
    </section>
);

export default Projects;
